<template>
    <div class="search-box">
        <input type="text"
               class="query"
               v-model="search"
               placeholder="Zoek naar specificatie"
        />
        <button type="submit" class="submit"><i aria-hidden="true" class="fa fa-search"></i></button>

        <div v-if="!filteredValues.length" class="alert alert-warning mt-3">
            Er zijn geen specificaties die voldoen aan uw zoekopdracht.
        </div>

        <table v-if="filteredValues.length"class="table table-striped mt-3">
            <tbody>
                <template v-for="value in filteredValues">
                    <tr class="border-bottom">
                        <td>{{value.AttributeDescription}}</td>
                        <td>{{value.ValueDescription}}
                            <div v-if="value.AttributeDescription === 'Klasse' && category">
                                <a v-if="value.ValueId < 0" class="small-text" :href="baseCategoryUrl">Toon alle producten van {{categoryTitle}}</a>
                                <a v-else class="small-text" :href="baseCategoryUrl+'?product_class='+value.ValueId">Toon alle producten van deze klasse</a>
                            </div>
                            <div v-if="value.AttributeDescription === 'Merk' && brand && value.ValueId < 0">
                               <a class="small-text"
                               :href="baseBrandUrl">
                                    Toon alle producten van {{brandTitle}}
                               </a>
                            </div>
                            <div v-if="value.AttributeDescription === 'Serie' && category && value.ValueId > 0">
                               <a class="small-text"
                               :href="baseCategoryUrl+'?model='+value.ValueId"
                                >
                                    Toon alle producten in deze serie
                               </a>
                            </div>

                        </td>
                    </tr>

                </template>
                <tr>
                  <td>Categorieën</td>
                  <td>
                    <a :href="breadcrumb.slug" v-for="breadcrumb in breadcrumbs" class="d-block">
                      {{ breadcrumb.title }}
                    </a>
                  </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<script>
    export default {

        props: [
            'query',
            'specifications',
            'breadcrumbs',
            'baseCategoryUrl',
            'baseBrandUrl',
            'category',
            'brand',
            'categoryTitle',
            'brandTitle'
        ],

        data() {
            return {
                collapsed: false,
                search: '',
                url: '',
                moreCount: 0,
                slice: 5
            }
        },

        computed: {
            filteredValues: function() {
                let self = this;
                return this.specifications.filter(function(value) {
                    if(value.AttributeDescription.toLowerCase().indexOf(self.search.toLowerCase()) >= 0){
                        return true;
                    }
                    return value.ValueDescription.toLowerCase().indexOf(self.search.toLowerCase()) >= 0
                });
            }
        }
    }
</script>
